import type React from 'react';

import { PaymentRequestButton } from 'src/app/shared/components/payments';

import { useStripeWallet } from './useStripeWallet';

type Props = {
	height?: number;
};

export const StripeWallet: React.FC<Props> = ({ height = 45 }) => {
	const { paymentType, ...rest } = useStripeWallet();
	if (paymentType === null) return null;
	return (
		<div className="w-full flex-1">
			<PaymentRequestButton {...rest} paymentType={paymentType} elementStyleOptions={{ height: `${height}px` }} />
		</div>
	);
};
